import type { FetchConfig } from '@nlo/nuxt-common/api/helper-types';
import type { paths } from '~/generated/krasloten-api';

export function createPointsApi(fetchConfig: FetchConfig) {
	const client = fetchConfig.createClient<paths>();

	return {
		getPoints() {
			return client.GET('/api/my/loyalty/total-points');
		},
	};
}
